module.exports = "<nav class=\"breadcrumb\">\r\n    <a class=\"breadcrumb-item\" href=\"#\">Home</a>\r\n    <span class=\"breadcrumb-item active\">Container</span>\r\n  </nav>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/breadcrumb/breadcrumb.component.html
// module id = ./src/app/breadcrumb/breadcrumb.component.html
// module chunks = main